import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {MarketingItemService} from '../service/marketing-item.service';

@Injectable()
export class MarketingItemsResolverService implements Resolve<any> {
  constructor(private marketingItemService: MarketingItemService) {
  }

  resolve(route: ActivatedRouteSnapshot,
          state: RouterStateSnapshot): Observable<any> {

    return this.marketingItemService.getMarketingItemItems();

  }
}
